import { Injectable, Inject } from '@angular/core';
import { HttpModule, Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import { APP_CONFIG, IAppConfig } from './../app.config';
import 'rxjs/add/observable/throw';

@Injectable()

export class StudentOpportunityService {

  private _token:string = localStorage.getItem('token');
  
  constructor(
    private http: Http, @Inject(APP_CONFIG) private config: IAppConfig
  ) {}

  
  getOpportunityById(oid,pid) {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'opportunities/get-opportunity-by-id/'+oid+'/'+pid, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }
  opportunityApplied(oid,pid) {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'opportunities/opportunity-applied/'+oid+'/'+pid, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }

  getopportunities(pid) {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'opportunities/get-opportunities-by-pid/'+pid, options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }

  getfouropportunities() {
    
    let token = this._token;
    let headers = new Headers({ 'Authorization': token });
    let options = new RequestOptions({ headers: headers });

    return this.http.get(this.config.apiEndpoint + 'opportunities/get-four-opportunities-by-pid', options).map((res => res.json()))
        .catch(this.handleErrorObservable);
  }

  
 removeOpportunity(oid,pid)
 {
  let token = this._token;
  let headers = new Headers({ 'Authorization': token });
  let options = new RequestOptions({ headers: headers });

  return this.http.get(this.config.apiEndpoint + 'opportunities/remove-opportunity/'+oid+'/'+pid, options).map((res => res.json()))
      .catch(this.handleErrorObservable);
 }
  
  private handleErrorObservable (error: Response | any) {
    /*if(!error.json().error){
      alert('Please check your internet connection');
    }*/
    return Observable.throw( error.json().error || 'Server Error' );
  }
 
}



// WEBPACK FOOTER //
// /home/aschmidt/websites/onefuturecv.org/onefuture-frontend/src/app/_services/student-opportunity.service.ts